import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { bootstrapCompanyAbout, loadCompanyAbout } from "../actions";
import { CompanyDescription, CompanyAboutResponse } from "../api";

export { CompanyDescription } from "../api";

export interface AboutState {
  isLoaded: boolean;
  descriptions: CompanyDescription[] | null;
}

const InitialState: AboutState = {
  isLoaded: false,
  descriptions: [],
};

function initState(state: AboutState, result: CompanyAboutResponse): AboutState {
  state.descriptions = result.company_descriptions;
  state.isLoaded = true;
  return state;
}

const aboutReducer = withImmer(reducerWithInitialState<AboutState>(InitialState))
  .case(bootstrapCompanyAbout, initState)
  .case(loadCompanyAbout.done, (state, { result }) => initState(state, result));

export default aboutReducer;



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/about.ts